// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay .sms-disclaimer{font-weight:200;line-height:.8rem!important;margin-bottom:1.5rem;font-size:.65rem!important}#openbay .sign-up-form-footer button{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
